<template>
  <span
    v-if="
      type?.toLowerCase() === 'payment_pending' ||
      type?.toLowerCase() === 'payment pending'
    "
    style="white-space: nowrap"
    class="rounded-md uppercase px-3 text-xs py-1 text-[var(--yellow100)] bg-[var(--yellow50)] font-semibold"
    >Payment Pending</span
  >
  <span
    v-if="type?.toLowerCase() === 'approved' || type?.toLowerCase() === 'approve'"
    class="px-3 uppercase text-xs py-1 ml-1 rounded-md text-[var(--green100)] bg-[var(--green50)] font-semibold"
    >Approved</span
  >

  <span
    v-if="type?.toLowerCase() === 'fulfilled'"
    class="px-3 py-1 ml-1 text-xs font-semibold uppercase rounded-md text-cyan-600 bg-cyan-100"
    >Fulfilled</span
  >

  <span
    v-if="type?.toLowerCase() === 'paid'"
    class="px-3 uppercase text-xs py-1 ml-1 rounded-md text-[var(--green100)] bg-[var(--green50)] font-semibold"
    >paid</span
  >

  <span
    v-if="
      type?.toLowerCase() === 'active' || type?.toLowerCase() === 'price active'
    "
    class="px-3 uppercase text-xs py-1 ml-1 rounded-md text-[var(--green100)] bg-[var(--green50)] font-semibold"
    >Active</span
  >

  <span
    v-if="type?.toLowerCase() === 'expired'"
    class="px-3 uppercase text-xs py-1 ml-1 rounded-md text-[var(--red100)] bg-[var(--red50)] font-semibold"
    >Expired</span
  >

  <span
    v-if="type?.toLowerCase() === 'denied'"
    class="px-3 uppercase text-xs py-1 ml-1 rounded-md text-[var(--red100)] bg-[var(--red50)] font-semibold"
    >Denied</span
  >

  <span
    v-if="type?.toLowerCase() === 'credit'"
    class="px-3 uppercase text-xs py-1 ml-1 rounded-md text-[var(--green100)] bg-[var(--green50)] font-semibold"
    >Credit</span
  >

  <span
    v-if="type?.toLowerCase() === 'debit'"
    class="px-3 uppercase text-xs py-1 ml-1 rounded-md text-[var(--red100)] bg-[var(--red50)] font-semibold"
    >Debit</span
  >
  <span
    v-if="type?.toLowerCase() === 'pending'"
    class="rounded-md uppercase px-3 text-xs py-1 text-[var(--yellow100)] bg-[var(--yellow50)] font-semibold"
    >Pending</span
  >
  <span
    v-if="type?.toLowerCase() === 'confirmed'"
    class="rounded-md uppercase px-3 text-xs py-1 text-[var(--green100)] bg-[var(--green50)] font-semibold"
    >confirmed</span
  >

  <span
    v-if="type?.toLowerCase() === 'completed'"
    class="rounded-md uppercase px-3 text-xs py-1 text-[var(--green100)] bg-[var(--green50)] font-semibold"
    >Completed</span
  >

  <span
    v-if="type?.toLowerCase() === 'payment_completed'"
    class="rounded-md uppercase px-3 text-xs py-1 text-[var(--green100)] bg-[var(--green50)] font-semibold"
    >payment_completed</span
  >
  <span
    v-if="type?.toLowerCase() === 'scheduled'"
    class="px-3 py-1 text-xs font-semibold text-indigo-600 uppercase bg-indigo-200 rounded-md"
    >scheduled</span
  >

  <span
    v-if="
      type?.toLowerCase() === 'partial_payment' ||
      type?.toLowerCase() === 'partial payment'
    "
    class="rounded-md uppercase px-3 text-xs py-1 text-[var(--yellow100)] bg-[var(--yellow50)] font-semibold"
    >partial_payment</span
  >

  <!-- <span
    v-if="type?.toLowerCase() === 'scheduled'"
    class="rounded-md uppercase px-3 text-xs py-1 text-[var(--green100)] bg-[var(--green50)] font-semibold"
    >scheduled</span
  > -->
  <span
    v-if="type?.toLowerCase() === 'suspended'"
    class="px-3 py-1 text-xs font-semibold text-purple-800 uppercase bg-purple-100 rounded-md"
    >suspended</span
  >
  <span
    v-if="
      type?.toLowerCase() === 'cancelled' ||
      type?.toLowerCase() === 'declined' ||
      type?.toLowerCase() === 'delete' ||
      type?.toLowerCase() === 'deleted'
    "
    class="px-3 py-1 text-xs font-semibold text-red-500 uppercase bg-red-100 rounded-md"
    >
    <!-- {{
      type?.toLowerCase() === "declined"
        ? "Declined"
        : "cancelled"
        ? "deleted"
        : "Deleted"
        ? "delete"
        : "Delete"
    }}   -->

    {{ type }}
    
    </span
  >

  <span
    v-if="
      type?.toLowerCase() === 'inactive' ||
      type?.toLowerCase() === 'price inactive'
    "
    class="rounded-md uppercase px-3 text-xs py-1 text-[var(--yellow100)] bg-[var(--yellow50)] font-semibold"
    >inactive</span
  >
</template>

<script>
export default {
  name: "PaymentStatusType",
  props: ["type"],
  mounted() {
    // console.log(this.type);
  },
};
</script>

<style></style>
